import * as React from 'react'
import { IconsModel } from './iconsModel'

const SvgInformation = (
    {
        color,
        width = 50,
        height = 50
    }: IconsModel
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
        <path
            d="M43.75 6.27v37.46H6.25V6.271h37.5zm-1.414 1.413H7.664v34.635h34.672V7.683zM28.423 19.641l.165.182v13.909l1.41 3.096v.199h-9.996v-.199l1.41-3.063V23.83l-1.36-2.169v-.248l8.37-1.772zm-3.763-8.329c2.238 0 3.862 1.54 3.862 3.544 0 2.103-1.624 3.56-3.862 3.56-2.205 0-3.796-1.457-3.796-3.56 0-2.037 1.591-3.544 3.796-3.544z"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
)

export default SvgInformation